// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gbIFoDjPpZz6IpGk3MlJ {
  background-color: #fff;
}

.AYYFBe4WwlozaPgPTbdw {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vA0TeSn8le8O64r3U3gu {
  max-width: 100%;
}

.qSX_XIJ_EeckJI7NhtWL {
  animation-duration: 3s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: vM5nAJH5CrZaCp7pT4jB;
  animation-timing-function: linear;
  background: #f6f7f8;
  background: linear-gradient(to right, #fafafa 8%, #f4f4f4 38%, #fafafa 54%);
  background-size: 400% 200%;
  height: 100%;
  width: 100%;
  position: absolute;
}

.nypmSGVLnJtc9LzPOdQK {
  visibility: hidden;
}

@keyframes vM5nAJH5CrZaCp7pT4jB {
  0% { background-position: -120% 0; }
  100% { background-position: 120% 0; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ImageWithSizeLoadingBlock/ImageWithSizeLoadingBlock.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,mCAAmC;EACnC,oCAAkC;EAClC,iCAAiC;EACjC,mBAAmB;EACnB,2EAA2E;EAC3E,0BAA0B;EAC1B,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC","sourcesContent":[".loadingCard {\n  background-color: #fff;\n}\n\n.wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.img {\n  max-width: 100%;\n}\n\n.gradient {\n  animation-duration: 3s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: placeHolderShimmer;\n  animation-timing-function: linear;\n  background: #f6f7f8;\n  background: linear-gradient(to right, #fafafa 8%, #f4f4f4 38%, #fafafa 54%);\n  background-size: 400% 200%;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n}\n\n.hiddenIfUnloaded {\n  visibility: hidden;\n}\n\n@keyframes placeHolderShimmer {\n  0% { background-position: -120% 0; }\n  100% { background-position: 120% 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingCard": `gbIFoDjPpZz6IpGk3MlJ`,
	"wrapper": `AYYFBe4WwlozaPgPTbdw`,
	"img": `vA0TeSn8le8O64r3U3gu`,
	"gradient": `qSX_XIJ_EeckJI7NhtWL`,
	"placeHolderShimmer": `vM5nAJH5CrZaCp7pT4jB`,
	"hiddenIfUnloaded": `nypmSGVLnJtc9LzPOdQK`
};
export default ___CSS_LOADER_EXPORT___;
